import React from 'react';
export function LovedOneStrip() {
  return <section aria-label="For family and friends of veterans" className="on-light border-b border-navy/10 bg-paper" data-id="element-133" data-mp="2349kqdy0w8mw">
      <p className="mx-auto max-w-7xl px-6 py-4 text-center text-lg leading-relaxed text-charcoal md:px-10" data-id="element-134" data-mp="1u06da4ncn3ih">
        Looking into this for a husband, wife, parent, or friend who served?{' '}
        <a href="/contact-us" className="inline-flex min-h-[48px] items-center px-1 font-semibold text-navy underline decoration-gold decoration-2 underline-offset-[6px] transition-colors duration-150 ease-out hover:text-honor" data-id="element-135" data-mp="22wfcbi7f0043">
          Start here
        </a>
      </p>
    </section>;
}